import React from 'react';
import { LogViewer } from '../pages/stateChangeLogs';
import {EventViewer} from '../pages/events';
import {apiVariables} from '../utils/variables';

var dateFormat = require('dateformat');
/* eslint eqeqeq: "off", no-unused-expressions: "off"*/



export class State extends React.Component{
    constructor(props){
        //The Cosntructor has to have a super(props) for the values to be utilised
        super(props);

        //I use two copies of the same data. One for the original, unchanged value, and another for the filtered one.
        //Only the filtered one gets displayed
        this.state = {solutions: null, filtered: null}

        //By using this, I can all everything like a regular class function, while using "this"
        this.filter = this.filter.bind(this);
        this.getSolutions = this.getSolutions.bind(this);
        this.filterError = this.filterError.bind(this);
        this.forceAllOk = this.forceAllOk.bind(this);
        this.reverseSolution = this.reverseSolution.bind(this);
    }


    forceAllOk(){
        //Loops over all the items on error and forces them to ok
        let filter = this.state.filtered;
        if(filter != null){
            filter = filter.filter(function(item){
                return item.status.search('ERROR') !== -1;
            });
            if(filter != null){
                filter.forEach(solution => {
                    this.reverseSolution(solution.solutionName);
                });
                this.getSolutions();
            }
        }
        
    }
    reverseSolution(solutionName){
        fetch(apiVariables.apiLink + 'solutionmonitor/status/reverseSolutionStatus?organization=' + encodeURIComponent(this.props.CurrentOrganization) + '&solutionName=' + encodeURIComponent(solutionName) + "&username=" + encodeURIComponent(this.props.username), { 
        method: 'post',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        
    }
    componentDidMount(){
        //When a component is loaded, run the function that fetches all the data
        this.getSolutions()
    }


    filter(e){
        //If the filter is the e event itself (An object), get the value of the input instead.
        if(typeof(e) === "object"){
            e = e.target.value
        }

        //Create a temp variable that holds the unchanged values.
        let filter = this.state.solutions;
        filter = filter.filter(function(item){
            //This filter only searches through the solution name. Can be modified to search for other fields.
            return item.solutionName.toLowerCase().search(
            e.toLowerCase()) !== -1;
        });
        //Once the filter has gone through, assign the changes to the renderer
        this.setState({filtered: filter});
    }
    filterError(e){

        //Filters so only error objects are shown.
        if(e.target.checked){
            let filter = this.state.filtered;
            filter = filter.filter(function(item){
                return item.status.search('ERROR') !== -1;
            });
            this.setState({filtered: filter});
        }
        else{
            let filter = this.state.solutions;
            this.setState({filtered: filter});
        }
        
    }
    getSolutions(){

        //Fetches the solution items from the api
        fetch(apiVariables.apiLink + 'solutionmonitor/overview/solutionOverview?organization=' + encodeURIComponent(this.props.CurrentOrganization), { 
        method: 'get',
        credentials: apiVariables.credentials,
        headers: apiVariables.apiHeader
        })
        .then((response) => response.json())
        .then((responseJson) => {
            this.setState({solutions: responseJson.document.SolutionMonitor, filtered: responseJson.document.SolutionMonitor});

            if(this.props.urlProps.match.params.searchTerm){
                this.filter(this.props.urlProps.match.params.searchTerm)
            }
           
        })
    }
    render(){
        console.log(this.props)
        if(this.state.solutions == null){
            //Render a placeholder message while the data is being fetched
            return (<h1>Fetching Data</h1>);
        }
        else{
            return (
            <div>

                {/*
                    The First div contains the control panel
                */}
                <div className="col-md-12">
                    <div className="searcher">
                    <input type="text" className="form-control col-md-12" placeholder="Search by name:" onChange={this.filter} defaultValue={this.props.urlProps.match.params.searchTerm}/>
                    </div>
                    <div className="col-md-12 solutionSearcher">
                        <div className="checkbox col-md-6 col-xs-12">
                        <label><input type="checkbox" onClick={this.filterError}/>Show only errors </label>
                        </div>
                        <div className="forceOK col-md-6">
                            <button className="btn btn-success pull-right" onClick={() => this.forceAllOk()}>Force solutions to OK</button>
                        </div>
                    </div>
                </div>

                {/*The container for the table*/}
                <div id="dashboard" className="row col-xl-12">
                    <div className="row col-xs-12">
                        <div className="row col-xl-12">
                            <div className="table-responsive">

                            {/*The table itself. I use bootstrap for most of the styling*/}
                            <table className="table table-bordered table-hover">
                                <thead>
                                    {/*The table head values. An onClick could be assigned for these to sort through the items.*/}
                                    <tr>
                                        <th className="text-center">Solution</th>
                                        <th className="text-center">Last Statechange</th>
                                        <th className="text-center">Last Status</th>
                                        <th className="text-center">Messages</th>   
                                                            
                                    </tr>
                                </thead>
                                    {/*The <tbody> tag is in the TableElements class, since each of them contain multiple rows.*/}
                                    {//The index part of it helps identifying which row is which.
                                        this.state.filtered.map(((solution, index) =>
                                            <TableElements CurrentOrganization={this.props.CurrentOrganization}solution={solution} key={solution.solutionName} reverseSolution={this.reverseSolution} refresh={this.forceUpdate}/>
                                        ))
                                    }
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            );
        }
        
    }
}
class TableElements extends React.Component{
    constructor(props){
        super(props);
        this.state = {shown: false, showLogs: false, solution: this.props.solution}
        this.handleChange = this.handleChange.bind(this);
        this.handleReverse = this.handleReverse.bind(this);
        this.showLogs = this.showLogs.bind(this);
        this.handleEventChange = this.handleEventChange.bind(this);
    }
    handleChange(){
        //this just reverses the shown boolean in the state
        this.setState({shown: !this.state.shown});
    }
    render(){
        return(
        <tbody>
                {/*The table row which containst the basic information about it*/}
                <tr className={'hover ' + this.state.solution.status} onClick={() => this.handleChange()}>
                    <td>{ this.state.solution.solutionName }</td>
                    {this.state.solution.lastStateChange !== null ? 
                        //If lastStateChange is there, assign the correct value. Otherwise it's never changed its state.
                        <td> {dateFormat(this.state.solution.lastStateChange, "dS mmmm, yyyy, HH:MM:ss")}	</td> :
                        <td>Never</td>
                    }
                    <td>{ this.state.solution.status }</td>
                    {/*Shorten the message so the longer ones don't ruin the tbale*/}
                    <td className="textColumn">{ this.state.solution.lastMessage == null ? "No Message" : this.state.solution.lastMessage.slice(0, 150)}</td>
                </tr>


                <tr> 
                    {/*I just change the className of the object to determine if it should be shown or not. */}
                    <td className="hiddenRow" colSpan="8"><div className={this.state.shown ? "acccordian-body" : "accordian-body hidden"}> 
                        <div className="col-md-12 accordion">
                            <div className="col-md-12">
                                <div className="col-md-2">
                                    <div className="col-sm-6 col-md-12 col-xs-6">
                                        <table className = "table">
                                            <thead>
                                                    <tr><th className="text-center">Statechange Logs</th></tr>
                                            </thead>
                                            <tbody>
                                                    <tr><td><span onClick={() => this.showLogs()} className="glyphicon glyphicon-modal-window clickable solution-glyph"></span></td></tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-sm-6 col-md-12 col-xs-6">
                                        <table className = "table">
                                            <thead>
                                                    <tr><th className="text-center">Force {this.state.solution.status === "ERROR" ? "OK" : "ERROR"}</th></tr>
                                            </thead>
                                            <tbody > 
                                                <tr>
                                                    {this.state.solution.status === 'ERROR' ? 
                                                        <td><span className="glyphicon glyphicon-ok-sign clickable solution-glyph" onClick={this.handleReverse}></span></td> :
                                                        <td><span className="glyphicon glyphicon-remove-sign clickable solution-glyph" onClick={this.handleReverse}></span></td> 	
                                                    }
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="col-md-12">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Server</th>
                                                <th className="text-center">Solution Description</th>
    
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{ this.state.solution.lastServer }</td>
                                                <td>{ this.state.solution.solutionDescription }</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <div className="col-md-12">
                                    <table className="table">
                                        <thead><tr><th className="text-center">Last Message</th></tr></thead>
                                        <tbody><tr><td className="textColumn">{ this.state.solution.lastMessage }</td></tr></tbody>
                                    </table>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                <div className="col-sm-6 col-md-12 col-xs-6">
                                    <table className = "table">
                                        <thead>
                                            <tr><th className="text-center">Edit</th></tr>
                                        </thead>
                                        <tbody>												
                                            <tr><td><span className="glyphicon glyphicon-check clickable solution-glyph"></span></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-sm-6 col-md-12 col-xs-6">
                                    <table className = "table">
                                        <thead>
                                            <tr><th className="text-center">Events</th></tr>
                                        </thead>
                                        <tbody>												
                                            <tr><td onClick={this.handleEventChange}><span className="glyphicon glyphicon-zoom-in clickable solution-glyph"></span></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {this.state.showEvents ?
                                <EventViewer solutionName={this.state.solution.solutionName} CurrentOrganization={this.props.CurrentOrganization} /> 
                                : null}
                            {this.state.showLogs ?
                                    <LogViewer solutionName={this.state.solution.solutionName} CurrentOrganization={this.props.CurrentOrganization}/>
                                 : null}
                        </div>
                    </div>
                </div>
                </td>
            </tr>
            
        </tbody>
        );
    }

    //Another couple of boolean flipping functions
    handleEventChange(e){
        
        this.setState({showEvents: !this.state.showEvents});
    }
    showLogs(e)
    {
        this.setState({showLogs: !this.state.showLogs});
    }
    handleReverse(e){
        let tempSolution = this.state.solution
        if(this.state.solution["status"] === "ERROR"){
            tempSolution["status"] = "OK"
        }
        else{
            tempSolution["status"] = "ERROR"
        }
        this.setState({solution: tempSolution})
        this.props.reverseSolution(this.props.solution.solutionName);
    }
}


// WEBPACK FOOTER //
// ./src/pages/state.js